export const LOGIN_SCREEN = '/login';
